import { render } from "./shopCart.vue?vue&type=template&id=cb7cecf0&scoped=true"
import script from "./shopCart.vue?vue&type=script&lang=js"
export * from "./shopCart.vue?vue&type=script&lang=js"

import "./shopCart.vue?vue&type=style&index=0&id=cb7cecf0&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7cecf0"]])

export default __exports__